export const fetchWorkerTypeAction = data => {
	return {
		type: 'FETCH_WORKER_TYPES_LIST',
		payload: data
	}
}